export default __webpack_public_path__ + "static/media/420506__jfrecords__uprising1.7493b764.wav";